export default "__VITE_ASSET__ChwLkRvJ__"